import { render } from "./ow-clients-sources.vue?vue&type=template&id=17c1fdff"
import script from "./ow-clients-sources.vue?vue&type=script&lang=js"
export * from "./ow-clients-sources.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__